import React from 'react';
import { Typography, FormHelperText, Button, Box } from "@mui/material";
import Select from "react-select";
import { BREED_OPTIONS_GROUPED } from '../../constants/steps';
import { useEnums } from '../../hooks/useEnums';

const AGE_DESCRIPTIONS = {
  'Kitten': 'Under 1 year (Kitten)',
  'Adult': '1-7 years (Adult)',
  'Senior': '7+ years (Senior)',
};

const KittyInfo = ({ formData, ageError, kittySubstep, onFormChange, onNext }) => {
  const enums = useEnums();

  // Warn if any lifestage is missing from AGE_DESCRIPTIONS
  Object.keys(enums.lifestages || {}).forEach((value) => {
    if (!AGE_DESCRIPTIONS[value]) {
      console.warn(`Lifestage "${value}" is missing from AGE_DESCRIPTIONS in KittyInfo.js`);
    }
  });
  // Handle form field changes
  const handleChange = (field, value) => {
    if (onFormChange) {
      onFormChange(field, value);
    }
  };
  
  // Render the appropriate substep based on kittySubstep prop
  const renderSubstep = () => {
    // Age
    if (kittySubstep === 0) {
      return (
        <>
          <Typography variant="h6" gutterBottom sx={{ mb: 0, fontWeight: 500 }} color={ageError ? 'error' : 'textPrimary'}>
            How old is your cat?
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
            Required
          </Typography>
          <div className="age-options-simple">
            {Object.keys(enums.lifestages || {}).map((value) => (
              <div
                key={value}
                onClick={() => handleChange('age', value)}
                className={`age-option-simple ${formData.age === value ? 'selected' : ''}`}
              >
                <span className="age-label">{AGE_DESCRIPTIONS[value] || value}</span>
              </div>
            ))}
          </div>
          {ageError && <FormHelperText error>Please select your cat's age to continue.</FormHelperText>}
        </>
      );
    }
    
    // Breed (substep 1)
    return (
      <>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="h6" gutterBottom sx={{ mb: 0, fontWeight: 500 }}>
              Select your cat's breed
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Optional
            </Typography>
          </Box>
          <Button 
            variant="text" 
            color="primary" 
            onClick={onNext}
            sx={{ textTransform: 'none' }}
          >
            Skip
          </Button>
        </Box>
        <Select 
          options={BREED_OPTIONS_GROUPED} 
          isClearable 
          placeholder="Select or skip" 
          value={formData.breed ? { label: formData.breed, value: formData.breed } : null} 
          onChange={opt => handleChange('breed', opt ? opt.value : '')} 
          className="breed-select"
        />
        <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic' }}>
          Different breeds may have different preferences.
        </Typography>
      </>
    );
  };

  return renderSubstep();
};

export default KittyInfo;